import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
/**
 * The tag page template, shown in place of Flarum's tag banner on every tag
 * page. One GrapesJS design for all tags: its `data-pb-field` markers are
 * filled with the tag's name (`__title__`), description and discussion count,
 * and `--pb-tag-color` carries the tag's colour for the design to use.
 *
 * The design is fetched once per visit, only on tag pages; the forum payload
 * says only whether one exists (pagebuilderTagTemplate).
 */
let design = null;
let loaded;
function load() {
  if (design) return;
  design = app.request({
    method: 'GET',
    url: app.forum.attribute('apiUrl') + '/pagebuilder/tag-template/render',
    errorHandler: () => {}
  }).then(r => r && r.html ? r : null).catch(() => null).then(r => {
    loaded = r;
    m.redraw();
    return r;
  });
}

/** Whether tag pages should show the template (one exists and it loaded). */
export function tagTemplateState() {
  if (!app.forum.attribute('pagebuilderTagTemplate')) return 'none';
  load();
  if (loaded === undefined) return 'loading';
  return loaded ? 'ready' : 'none';
}

// 🚨 The attribute is `model`, not `tag`: Mithril takes an attrs object with a
// `tag` property for a child vnode, and the component got no attributes at all.
export default class TagTemplateHero extends Component {
  view() {
    const tag = this.attrs.model;
    const color = tag && tag.color && tag.color() || '';
    return m("div", {
      className: "PB-TagTemplate",
      key: tag.id(),
      style: color ? {
        '--pb-tag-color': color
      } : undefined,
      onbeforeupdate: () => false
    }, m.trust(`<style>${loaded?.css || ''}</style>${loaded?.html || ''}`));
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    const tag = this.attrs.model;
    const values = {
      __title__: tag.name() || '',
      description: tag.description() || '',
      discussionCount: String(tag.discussionCount() ?? '')
    };
    vnode.dom.querySelectorAll('[data-pb-field]').forEach(n => {
      const key = n.getAttribute('data-pb-field') || '';
      if (key in values) n.textContent = values[key];
    });
  }
}
flarum.reg.add('ernestdefoe-page-builder', 'forum/components/TagTemplateHero', TagTemplateHero);